

    import { computed, defineComponent } from 'vue'
    import Anchor from './Anchor.vue'
    import Container from './Container.vue'
    import ThemeChanger from './ThemeChanger.vue'
    import ContactHeader from './ContactHeader.vue'
    import SocialMediaButton from './SocialMediaButton.vue'
    import Column from './Grid/Column.vue'
    import Grid from './Grid/Grid.vue'
    import Paragraph from './Paragraph.vue'
    import { useCms } from '../compositions/UseCms'
    import { Route } from '../enums/Route'
    import { Theme } from '../enums/Theme'
    import { useRoute } from 'vue-router'

    export default defineComponent({
        name: 'Footer',
        components: {
            ContactHeader,
            Container,
            Anchor,
            Paragraph,
            Grid,
            Column,
            SocialMediaButton,
            ThemeChanger
        },
        setup() {

            const route = useRoute()
            const { footer } = useCms()

            return {
                Route,
                Theme,
                cms: footer,
                isContactPage: computed(() => route.name === Route.Contact),
                socialMedia: [
                    {
                        name: 'LinkedIn',
                        link: 'https://linkedin.com/company/digital-creative-asia/'
                    },
                    {
                        name: 'Instagram',
                        link: 'https://instagram.com/dc.asia'
                    }
                ]
            }

        }
    })

